import { setCountNews } from '../../action';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = 0;

export default createReducer(
  [forAction(setCountNews, identityPayload)],
  initialState,
);
